import React, { createContext, useContext, useEffect, useState } from 'react'
import { removeLocalStorageData } from '../../utils/storage/storage'
import Cookies from 'js-cookie'
import { BaseService } from '../../services/BaseService'
import { statusResponse } from '../../constants/response'
import { CustomError } from '../../utils/error/customeError'
import { clearISTCameraSession } from '../../utils/clearISTCameraSession'

const AuthContext = createContext()

const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(Cookies.get('user'))

  useEffect(() => {
    const checkUser = Cookies.get('user')
    if (checkUser) {
      setUser(checkUser)
    }
  }, [user])

  async function login(userData) {
    try {
      const service = new BaseService('/m_login_2')
      const payload = userData
      const res = await service.login(payload)

      if (res?.status === statusResponse.failed) {
        const err = new CustomError()
        err.error403({
          message: res.msg,
        })
      }

      const resUser = res.data[0]
      const userLocal = {
        id: resUser.id,
        position: JSON.parse(resUser.kategori_user),
        email: resUser.email,
        fullname: resUser.nama_lengkap,
        nik: resUser.nik_ktp,
        no: resUser.no_telp,
        soal: resUser.flagging_soal,
      }

      localStorage.setItem('userLang', resUser.flagging_eng === 'YES' ? 'en' : 'id')

      const toString = JSON.stringify(userLocal)
      const encode = btoa(toString)

      //check data question.
      if (localStorage.getItem('question')) {
        const question = JSON.parse(localStorage.getItem('question'))
        if (question.userId !== resUser.id) localStorage.removeItem('question')
      }

      if (localStorage.getItem('questionIst')) {
        const question = JSON.parse(localStorage.getItem('questionIst'))
        if (question.userId !== resUser.id) {
          clearISTCameraSession()
          localStorage.removeItem('questionIst')
        }
      }

      if (localStorage.getItem('questionKraep')) {
        const question = JSON.parse(localStorage.getItem('questionKraep'))
        if (question.userId !== resUser.id) localStorage.removeItem('questionKraep')
      }

      if (localStorage.getItem('geoLocation')) localStorage.removeItem('geoLocation')

      Cookies.set('user', encode, {
        expires: 1,
      })
      setUser(encode)
    } catch (error) {
      throw error || 'Something wrong!'
    }
  }

  function logout() {
    removeLocalStorageData('user')
    removeLocalStorageData('userLang')
    Cookies.remove('user')
    setUser(false)
  }

  return <AuthContext.Provider value={{ user, login, logout }}>{children}</AuthContext.Provider>
}
const useAuth = () => {
  const user = useContext(AuthContext)

  if (!user) {
    return false
  }
  return user
}

export { AuthProvider, useAuth }
